const MailBoxIcon = () => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.2207 5L11.2207 8.5L16.2207 5"
        stroke="#31493C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.22266 13V3C1.22266 1.89543 2.11809 1 3.22266 1H19.2227C20.3273 1 21.2227 1.89543 21.2227 3V13C21.2227 14.1046 20.3273 15 19.2227 15H3.22266C2.11809 15 1.22266 14.1046 1.22266 13Z"
        stroke="#31493C"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default MailBoxIcon;
